import React, { useState, useEffect } from "react";

import { MessageCircle, X } from "lucide-react";

import { WHATSAPP_URL } from "@/lib/brand";

export default function FloatingWhatsApp() {
  const [visible, setVisible] = useState(false);

  const [showTip, setShowTip] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);

    window.addEventListener("scroll", onScroll);

    const t = setTimeout(() => setShowTip(true), 3000);

    return () => {
      window.removeEventListener("scroll", onScroll);

      clearTimeout(t);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-5 right-5 z-50 flex items-end gap-3"
      data-testid="floating-whatsapp-wrapper"
    >

      {/* Tooltip */}
      {showTip && (
        <div className="bg-white border border-[var(--gf-border)] gf-shadow-soft rounded-2xl px-4 py-3 max-w-[240px] hidden sm:block">

          <div className="flex items-start justify-between gap-2">

            <p className="text-xs text-[var(--gf-text-2)] leading-snug">
              🚀 Want more customers from Google?
              <span className="font-semibold text-[var(--gf-primary)]">
                {" "}Chat with GrowFlow on WhatsApp.
              </span>
            </p>

            <button
              onClick={() => setShowTip(false)}
              className="text-[var(--gf-text-2)] hover:text-[var(--gf-primary)]"
              aria-label="Close tooltip"
            >
              <X className="h-3.5 w-3.5" />
            </button>

          </div>
        </div>
      )}

      {/* Floating Button */}
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp-btn"
        className="group relative inline-flex items-center justify-center h-16 w-16 rounded-full bg-[var(--gf-green)] hover:bg-[var(--gf-green-deep)] text-white shadow-[0_10px_30px_-8px_rgba(37,211,102,0.6)] transition-all duration-300 hover:-translate-y-1 hover:scale-105"
        aria-label="Chat on WhatsApp"
      >

        {/* Pulse Animation */}
        <span className="absolute inset-0 rounded-full bg-[var(--gf-green)] opacity-60 animate-ping duration-1000" />

        {/* Icon */}
        <MessageCircle className="relative h-7 w-7" />

      </a>
    </div>
  );
}
